module.exports = "//static.hsappstatic.net/LoginUI/static-1.14611/img/unsupported-browser.svg"